import { DirectiveBase } from './../../components/angular-directive-base.directive';

/**
 * A directive that calls a supplied method when the enter keys has been pressed on the elemtn that the directive is placed on
 */
export class NgEnter extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'A';
    this.link = (scope, element, attrs) => {
      this.LinkFunction(scope, element, attrs);
    };
  }

  /**
   * A function that executes upon directive instantiation
   * @param scope the isolated scope available to the directive
   * @param element the html element that the directive was placed on
   * @param attrs the attributes that are present on the html element that the directive was placed on
   */
  public LinkFunction(scope, element: JQuery, attrs) {
    element.bind('keydown keypress', (event) => {
      if (event.which === 13) {
        scope.$apply(() => {
          scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    });
  }
}